import { Button, Input, Modal, Select } from "antd";
import React from "react";
import PlateNumber from "../../../components/PlateNumber";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";
import { checkValidEngNumbers, onChangeProvince } from "../../../core/utils";
import CloseModalButton from "../../../components/CloseModalButton/CloseModalButton";

const AddCar = (props) => {
  const {
    isModalOpen,
    setIsModalOpen,
    provinces,
    cities,
    setCities,
    carTypes,
    usage,
    capacity_unit,
    year_range,
    brands,
    models,
    showManuFactoringYearsByCarModel,
    getCarsBrands,
    getCarsModels,
    addCarStates,
    handleAddCarState,
    onAddCarValues,
  } = props;
  const { Option } = Select;
  return (
    <>
      <div className="w-100 ">
        <Button
          className="button-primary w-220px  flex flex-items-center flex-content-center"
          onClick={() => setIsModalOpen(true)}
        >
          <i className="far fa-plus pr-2 pb-2" />
          <span>Add Car</span>
        </Button>
      </div>
      <Modal
        open={isModalOpen}
        title="Add Car"
        onCancel={() => {
          setIsModalOpen(false);
          handleAddCarState({
            number_plate_part_1: "",
            number_plate_part_2: "",
            number_plate_alphabet: "",
            number_plate_city_code: "",
          });
        }}
        footer={false}
        closable={true}
        closeIcon={
          <CloseModalButton isCloseIcon close={() => setIsModalOpen(false)} />
        }
      >
        <div className="flex flex-wrap flex-content-space-between">
          <FormWrapper>
            <Select
              className="border-black-8 "
              placeholder="Car Type"
              onChange={(value) => {
                handleAddCarState({
                  car_type: value,
                  brand: null,
                  car_id: null,
                });
                getCarsBrands(value);
              }}
              value={addCarStates.car_type}
            >
              {carTypes.map((carType) => {
                return (
                  <Option value={carType[0]} name={carType[0]}>
                    {carType[1]}
                  </Option>
                );
              })}
            </Select>
            <Select
              className="border-black-8 "
              placeholder="Brand"
              onChange={(value) => {
                handleAddCarState({
                  brand: value,
                  year: null,
                  car_id: null,
                });
                getCarsModels(value);
              }}
              value={addCarStates.brand}
              disabled={!addCarStates.car_type}
            >
              {brands.map((brand) => {
                return (
                  <Option key={brand.id} value={brand.id}>
                    {brand.name}
                  </Option>
                );
              })}
            </Select>
            <Select
              className="border-black-8 "
              placeholder="Model"
              onChange={(value) => {
                handleAddCarState({
                  car_id: value,
                  year: null,
                });
              }}
              value={addCarStates.car_id}
              disabled={!addCarStates.brand}
            >
              {models.map((model) => {
                return (
                  <Option key={model.id} value={model.id}>
                    {model.name}
                  </Option>
                );
              })}
            </Select>
            <Select
              className="border-black-8 "
              placeholder="Year"
              onChange={(value) => handleAddCarState({ year: value })}
              value={addCarStates.year}
              disabled={!addCarStates.car_id}
            >
              {showManuFactoringYearsByCarModel(
                models.find((model) => model.id === addCarStates.car_id),
                year_range
              ).map((year, ydx) => {
                return (
                  <Option key={ydx} value={year}>
                    {year}
                  </Option>
                );
              })}
            </Select>
            <Select
              className="border-black-8 "
              placeholder="Province"
              onChange={(value) =>
                onChangeProvince(
                  value,
                  () => {
                    handleAddCarState({
                      province_id: value,
                      city_id: null,
                    });
                  },
                  setCities
                )
              }
              value={addCarStates.province_id}
            >
              {provinces &&
                provinces.map((province) => {
                  return <Option value={province.id}>{province.name}</Option>;
                })}
            </Select>
            <Select
              className="border-black-8 "
              placeholder="City"
              onChange={(value) =>
                handleAddCarState({
                  city_id: value,
                })
              }
              value={addCarStates.city_id}
              disabled={!addCarStates.province_id}
            >
              {cities.map((city) => {
                return <Option value={city.id}>{city.name}</Option>;
              })}
            </Select>
            <PlateNumber
              data={addCarStates}
              handleGetPlateNumber={handleAddCarState}
            />
            <Select
              className="border-black-8 mb-10"
              onChange={(value) =>
                handleAddCarState({
                  usage: value,
                })
              }
              placeholder="Car Usage"
              value={addCarStates.usage}
            >
              {usage.map((usage) => {
                return (
                  <Option key={usage[0]} value={usage[0]}>
                    {usage[1]}
                  </Option>
                );
              })}
            </Select>

            <Input
              type="text"
              placeholder="Car Capacity"
              className="border-black-8 mb-10"
              onKeyDown={checkValidEngNumbers}
              value={addCarStates.capacity}
              onChange={(e) =>
                handleAddCarState({
                  capacity: e.target.value,
                })
              }
            />

            <Select
              className="border-black-8 mb-10"
              onChange={(value) =>
                handleAddCarState({
                  capacity_unit: value,
                })
              }
              placeholder="Capacity Unit"
              value={addCarStates.capacity_unit}
            >
              <Option value={null}>Capacity Unit</Option>
              {capacity_unit.map((capacity_unit) => {
                return (
                  <Option key={capacity_unit[0]} value={capacity_unit[0]}>
                    {capacity_unit[1]}
                  </Option>
                );
              })}
            </Select>
            <Input
              type="text"
              placeholder="VIN"
              className="border-black-8 input-size mb-10"
              value={addCarStates.vin}
              onChange={(e) =>
                handleAddCarState({
                  vin: e.target.value,
                })
              }
            />
            <Button className="button-primary w-100" onClick={onAddCarValues}>
              Add Car
            </Button>
          </FormWrapper>
        </div>
      </Modal>
    </>
  );
};

export default AddCar;
